import { render, staticRenderFns } from "./document-test-modal.vue?vue&type=template&id=024fac0e&scoped=true"
import script from "./document-test-modal.vue?vue&type=script&lang=js"
export * from "./document-test-modal.vue?vue&type=script&lang=js"
import style0 from "./document-test-modal.vue?vue&type=style&index=0&id=024fac0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024fac0e",
  null
  
)

export default component.exports